/**
 * 将小程序API callback形式转换成Promise形式
 * @param func 小程序API
 */
export function wxPromisify(func) {
    if (typeof func !== 'function')
        return func;
    return (...args) => new Promise((resolve, reject) => {
        // @ts-ignore
        const [opt, ...rest] = args;
        func({
            ...opt,
            success: resolve,
            fail: reject,
        }, ...rest);
    });
}
//# sourceMappingURL=promisify.js.map